/** @jsx jsx */
import { Text } from '@bottlebooks/gatsby-design-system';
import {
  ToggleFavorite,
  useFavorite,
} from '@bottlebooks/gatsby-plugin-bookmarks/src';
import {
  ProductHeaderDetails,
  ProductName,
  ProductProducer,
  hasDifferentExhibitor,
} from '@bottlebooks/gatsby-theme-event/src/components/Product/ProductHeader';
import ProductStand from '@bottlebooks/gatsby-theme-event/src/components/Product/ProductStand';
import ProductImageCol from '@bottlebooks/gatsby-theme-event/src/components/ProductPage/ProductImageCol';
import ProductNavigation from '@bottlebooks/gatsby-theme-event/src/components/ProductPage/ProductNavigation';
import {
  ProductMainCol,
  ProductPageHeaderRow,
} from '@bottlebooks/gatsby-theme-event/src/components/ProductPage/ProductPageHeader';
import useLink from '@bottlebooks/gatsby-theme-event/src/useLink';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import ProductCategory from '../Product/ProductCategory';
import ProductMedal from '../Product/ProductMedal';

export * from '@bottlebooks/gatsby-theme-event/src/components/EventProductPage/EventProductPageHeader';

export default function ProductPageHeader({
  product,
  next,
  previous,
  standPath,
  overlapImage,
  ...rest
}) {
  const link = useLink();
  const favorite = useFavorite(
    product && { type: 'product', id: product.productId }
  );
  const hasOtherExhibitor = hasDifferentExhibitor(product);
  return (
    <ProductPageHeaderRow sx={{ justifyContent: 'center' }} {...rest}>
      <ProductImageCol product={product} overlap={overlapImage} />
      <ProductMainCol>
        <Text
          sx={{ width: '100%', display: 'flex', gap: 3, marginBottom: 3.5 }}
        >
          <ProductMedal product={product} sx={{ marginLeft: [null, -2.5] }} />
          <ProductCategory product={product} sx={{ flex: '1 1 0' }} />
        </Text>
        {/* <ProductLabel product={product} sx={{ marginBottom: 3.5 }} /> */}
        <ProductStand
          stand={product?.registration?.stand || product?.stand}
          exhibitor={hasOtherExhibitor && product?.exhibitor}
          to={hasOtherExhibitor && standPath}
        />
        <ProductProducer
          producer={product?.producer}
          to={link.producer(product.producer)}
        />
        <ProductName as="h1" product={product} />
        <ProductHeaderDetails product={product} showMorePricingInfo={true} />
        <ToggleFavorite
          sx={{ marginTop: 3, marginLeft: -2, padding: 0, paddingRight: 3 }}
          isToggled={favorite.isSet}
          onClick={favorite.toggle}
        />
      </ProductMainCol>

      <ProductNavigation previous={previous} next={next} />
    </ProductPageHeaderRow>
  );
}

export const fragment = graphql`
  fragment BestOfBurgenland_ProductPageHeader on Bottlebooks_RegisteredProduct {
    ...BestOfBurgenland_ProductMedal
    ...BestOfBurgenland_ProductCategory
  }
`;
